import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation PayWithWorldpayMutation($input: PayWithWorldpayInput!) {
    payWithWorldpay(input: $input) {
      order {
        id
        orderid
        state
        payment {
          state
        }
      }
      redirectUrl
    }
  }
`;

function commit(environment, orderId, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        orderId,
        successPath: '/checkout/worldpay-success',
        pendingPath: '/checkout/worldpay-pending',
        cancelPath: '/checkout/worldpay-cancel',
        failurePath: '/checkout/worldpay-failure',
        errorPath: '/checkout/worldpay-error',
      },
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback &&
          callback(
            null,
            response.payWithWorldpay.order,
            response.payWithWorldpay.redirectUrl,
          );
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };
